/* app/js/src/components/calendar/expandable/calendar-expandable-progress-bar/calendar-expandable-progress-bar.component.scss */
.indicator-bar {
  position: absolute;
  top: 0;
  bottom: 0;
  left: 0;
  right: 0;
  width: auto;
  height: auto;
}
/*# sourceMappingURL=calendar-expandable-progress-bar.component.css.map */
